export default {
  extraFacilities: []
}
